import { _defineProperty } from "@slyte/core/src/lyte-utils";
import { Route } from "../../../node_modules/@slyte/router/index.js";
let LinkButtonComp;

class Link extends Route {
  render() {
    return { outlet: '#zcatcomponent', component: LinkButtonComp };
  }

  static actions(arg1) {
    return Object.assign(super.actions({}), arg1);
  }

  _() {
    _;
  }

  getRequirements() {
    arguments[1].push(import(
      /* webpackChunkName: "components/javascript/zcat-components/link-button-comp" */
      "../../../components/javascript/zcat-components/link-button-comp"
    ).then(function(res) {
      LinkButtonComp = res.LinkButtonComp;
    }));

    
;
  }
}

export { Link };
